export default {
  mediaSalesByChannel: '{kpi} de Mídia por Canal',
  dataView: 'Visualização de Dados',
  close: 'Fechar',
  refresh: 'Atualizar',
  saveAsImage: 'Salvar como Imagem'
}
